import { useAnalytics, useMetrics } from "@sail/observability";
import { useCallback } from "react";
import { reportUnderPrefetchedQueries } from "../../internal/prefetching/usePrefetchCounter";
export default function useInstrumentUnderPrefetchedQueries() {
    const metrics = useMetrics();
    const analytics = useAnalytics();
    return useCallback(()=>{
        reportUnderPrefetchedQueries(metrics, analytics);
    }, [
        metrics,
        analytics
    ]);
}

//# sourceMappingURL=useInstrumentUnderPrefetchedQueries.js.map